module.exports = __webpack_public_path__ + "static/media/Monday_Step2_Image8.9f30d766.webp";